import {
  getTokens
} from '../../config/apiServe/scanner'

/** 搜索/检索时单次拉取的条数上限 */
const SEARCH_FETCH_SIZE = 999

export default {
  data() {
    return {
      coinSearch: "",
      baseCoin: require("../../assets/img/coin/baseCoin.png"),
      pages: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      Tokens: [],
      TokensList: [],
      loading: false,
      searchMode: false,
      searchTableLoading: false
    };
  },
  computed: {
    LoadingSucc() {
      return !this.loading && !this.searchTableLoading;
    }
  },
  mounted() {
    this.loadTokenList();
  },
  methods: {
    mapTokenRow(item, index) {
      return {
        ...item,
        index: index + 1,
        value: item.symbol,
        icon: this.baseCoin,
        createdTime: item.deploy_time,
        introduce: item.name || ''
      }
    },
    goTokenDetail(row) {
      if (!row || !row.address) return
      this.$router.push({
        path: '/tokenDetail',
        query: { tokenAdr: row.address }
      })
    },
    selectSearchSuggestion(item) {
      this.coinSearch = item.value || item.symbol || ''
      if (item.address) {
        this.goTokenDetail(item)
      }
    },
    // 加载Token列表数据
    async loadTokenList() {
      this.loading = true;
      try {
        const response = await getTokens(this.pages.currentPage, this.pages.pageSize);
        if (response.code === 0 && response.data) {
          const { tokens, total } = response.data;
          const list = tokens || []
          const startIndex = (this.pages.currentPage - 1) * this.pages.pageSize
          this.TokensList = list.map((item, i) =>
            this.mapTokenRow(item, startIndex + i)
          );
          this.pages.total = total;
          this.Tokens = this.TokensList;
          this.searchMode = false
        } else {
          this.Tokens = [];
          this.TokensList = [];
          this.pages.total = 0;
          this.searchMode = false
        }
      } catch (error) {
        console.error('加载Token列表失败:', error);
        this.Tokens = [];
        this.TokensList = [];
        this.pages.total = 0;
        this.searchMode = false
      } finally {
        this.loading = false;
      }
    },
    async searchToken(token) {
      const q = (token || '').trim()
      if (!q) {
        if (this.searchMode) {
          this.searchMode = false
          await this.loadTokenList()
        } else {
          this.$notify({
            title: '提示',
            message: '请输入搜索关键词',
            type: 'warning'
          })
        }
        return
      }
      this.searchTableLoading = true
      try {
        // 以 0x 开头视为合约地址搜索
        const isAddress = q.startsWith('0x')
        const res = await getTokens(1, SEARCH_FETCH_SIZE, isAddress ? '' : q, isAddress ? q : '')
        if (res.code === 0 && res.data) {
          const tokens = res.data.tokens || []
          this.searchMode = true
          this.Tokens = tokens.map((item, i) => this.mapTokenRow(item, i))
          if (!tokens.length) {
            this.$notify({
              title: '提示',
              message: '没有此Token',
              type: 'warning'
            })
          }
        } else {
          this.searchMode = true
          this.Tokens = []
          this.$notify({
            title: '提示',
            message: '没有此Token',
            type: 'warning'
          })
        }
      } catch (e) {
        console.error('搜索Token失败:', e)
        this.searchMode = true
        this.Tokens = []
        this.$notify({
          title: '提示',
          message: '搜索失败，请稍后重试',
          type: 'error'
        })
      } finally {
        this.searchTableLoading = false
      }
    },
    sortToken(sort) {
      if (sort.order !== "ascending" && sort.order !== "descending") return
      const order = sort.order === "ascending"
      if (this.searchMode) {
        const sorted = [...this.Tokens].sort(this.compare(sort.prop, order))
        sorted.forEach((item, i) => { item.index = i + 1 })
        this.Tokens = sorted
        return
      }
      this.TokensList = [...this.TokensList].sort(this.compare(sort.prop, order))
      this.TokensList.forEach((item, i) => {
        const startIndex = (this.pages.currentPage - 1) * this.pages.pageSize
        item.index = startIndex + i + 1
      })
      this.Tokens = this.TokensList
    },
    compare(attr, rev) {
      if (rev == undefined) {
        rev = 1;
      } else {
        rev = rev ? 1 : -1;
      }
      return function(a, b) {
        a = a[attr];
        b = b[attr];
        if (a < b) {
          return rev * -1;
        }
        if (a > b) {
          return rev * 1;
        }
        return 0;
      };
    },
    async querySearch(queryString, cb) {
      const q = (queryString || '').trim()
      if (!q) {
        cb([])
        return
      }
      try {
        // 以 0x 开头视为合约地址搜索
        const isAddress = q.startsWith('0x')
        const res = await getTokens(1, 20, isAddress ? '' : q, isAddress ? q : '')
        if (res.code === 0 && res.data && res.data.tokens) {
          const results = (res.data.tokens || []).map(item => ({
            value: item.symbol,
            icon: this.baseCoin,
            symbol: item.symbol,
            name: item.name,
            address: item.address
          }))
          cb(results)
        } else {
          cb([])
        }
      } catch (e) {
        cb([])
      }
    },
    pageChange(page) {
      this.pages.currentPage = page;
      this.loadTokenList();
    },
    sizeChange(size) {
      this.pages.currentPage = 1;
      this.pages.pageSize = size;
      this.loadTokenList();
    }
  }
};
